import type { JSX } from "react";

import Grid from "@mui/material/Grid";
import {
  AttributeLabel,
  AttributeResetButton,
  ConfigurationAttributeInfo,
  INFO_LAYOUT_PROPS_DEFAULTS,
  InfoLayoutProps,
} from "@plansoft-configuration-renderer/components";
import {
  TextMode,
  TextModeUnion,
} from "@plansoft-configuration-renderer/framework";
import { CustomLayoutProps } from "@plansoft-configuration-renderer/layout";

export type AttributeHeadlineProps = CustomLayoutProps & {
  showResetButton?: boolean;
  textMode?: TextModeUnion;
  infoProps?: InfoLayoutProps;
};

export function CustomAttributeHeadline(
  props: AttributeHeadlineProps,
): JSX.Element {
  const {
    infoProps = INFO_LAYOUT_PROPS_DEFAULTS,
    textMode = TextMode.PlainText,
    showResetButton = false,
  } = props;

  return (
    <Grid
      container
      className="attribute-headline"
      sx={{
        alignItems: "center",
        justifyContent: "flex-start",
      }}
    >
      <Grid>
        <AttributeLabel textMode={textMode} />
      </Grid>
      <Grid sx={{ ">button": { py: 0, height: "1em" } }}>
        <ConfigurationAttributeInfo {...infoProps} />
      </Grid>
      {showResetButton && (
        <Grid>
          <AttributeResetButton />
        </Grid>
      )}
    </Grid>
  );
}
